/**
 * Markers topic manager.
 *
 * Handles messages on the "markers" namespace. The backend (see
 * marker_service.py) publishes three past-tense event types:
 *   - "updated" -> upsert marker (emitted for BOTH creates and patches)
 *   - "moved"   -> upsert marker (position change)
 *   - "deleted" -> remove marker from the store
 *
 * Incoming payloads are CoT protobuf binaries which are decoded
 * via cotUtils before being dispatched to the Redux markers slice.
 * The upsert path uses markersSlice.addMarker, which is a create-or-merge
 * reducer, so the same action is correct for both first-sighting and
 * subsequent position updates.
 */

import { TopicManager } from "../types";
import { AppDispatch } from "../../../store";
import { markersSlice } from "../../../store/markersSlice";
import { parseCotMessage, cotToMapEntity } from "../../../utils/cotUtils";

export class MarkersManager implements TopicManager {
    constructor(private dispatch: AppDispatch) {}

    handleMessage(eventType: string, payload: Buffer): void {
        const parsed = parseCotMessage(new Uint8Array(payload));
        console.log("[MQTT markers/" + eventType + "] parsed CoT:", parsed);
        if (!parsed) return;

        switch (eventType) {
            case "deleted":
                this.dispatch(markersSlice.actions.removeMarker(parsed.uid));
                break;
            case "updated":
            case "moved": {
                const entity = cotToMapEntity(parsed);
                console.log("[MQTT markers/" + eventType + "] MapEntity:", entity);
                if (entity) {
                    this.dispatch(markersSlice.actions.addMarker(entity));
                }
                break;
            }
        }
    }
}
